<template>
  <div class="boxall">
    <div class="page-head">
      <div class="title">示范基地</div>
      <span class="btn-container">
        <button class="detail-btn" @click="openDetail">
          {{ opened ? '返回' : '详情' }}
          <img src="../assets/images/more_arrow.png" alt="icon" />
        </button>
      </span>
    </div>

    <div class="boxnav">
      <div class="bg-image">
        <div class="content">
          <ul class="details">
            <li>
              <div class="item-box">
                <div class="item-info">
                  <div class="item-value">
                    <span class="num">2</span>
                    <span class="unit">个</span>
                  </div>
                  <div class="item-label">2万亩综合养殖区</div>
                </div>
              </div>

              <div class="item-box">
                <div class="item-info">
                  <div class="item-value">
                    <span class="num">12</span>
                    <span class="unit">个</span>
                  </div>
                  <div class="item-label">3000亩以上集中区</div>
                </div>
              </div>
            </li>

            <li>
              <div class="item-box">
                <div class="item-info">
                  <div class="item-value">
                    <span class="num">4</span>
                    <span class="unit">个</span>
                  </div>
                  <div class="item-label">1万亩规模示范区</div>
                </div>
              </div>

              <div class="item-box">
                <div class="item-info">
                  <div class="item-value">
                    <span class="num">300</span>
                    <span class="unit">个</span>
                  </div>
                  <div class="item-label">50亩以上标准化基地</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DemoBase',

  props: {
    activeComp: {
      type: String,
      default: 'CenterMap'
    }
  },

  computed: {
    opened() {
      return this.activeComp === 'BaseDetail'
    }
  },

  methods: {
    openDetail() {
      this.$emit('switchCenter')
    }
  }
}
</script>

<style scoped>
.bg-image {
  width: 100%;
  height: 100%;
  background: url('../assets/images/base.jpg') no-repeat center center;
  background-size: cover;
  border-radius: 12px;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.content {
  height: 100%;
}

.content > ul {
  display: flex;
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  gap: 12px;
  justify-content: center;
  align-items: end;
}

/* li {
  flex: 0 0 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 5px;
  box-sizing: border-box;
} */

.details > li > div {
  flex: 1; /* 平均分配列高度 */
  width: 100%;
  border-radius: 6px;
  border: 1px solid rgb(5 175 211 / 91%);
  background: rgba(0, 0, 0, 0.61);
}

li > div.item-box {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center; /* 垂直居中 */
  /* padding: 0 2px; */
  box-sizing: border-box;
  margin: 4px;
}

.item-icon {
  height: 40px;
  width: 40px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  margin-left: 16px;
  border-radius: 50%;
  border: 2.4px solid rgb(5 175 211 / 91%);
  box-shadow: 0 0 16px rgba(0, 191, 255, 0.4), inset 0 0 70px rgba(0, 191, 255, 0.5),
    inset 0 0 2px rgba(255, 255, 255, 0.3);
}

.item-icon img {
  width: 20px;
  height: 20px;
}

.item-info {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* padding-bottom: 4px; */
  gap: 12px;
  padding: 6.4px 12px;
}

/* 第一行：数字 + 单位 */
.item-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.num {
  font-size: 28px;
  font-weight: bold;
  color: #00cfff;
  font-family: ds-digitalnormal !important;
}

.unit {
  font-size: 16px;
  color: #7ecfea;
}

.item-label {
  font-size: 12px;
  color: #8fb8c8;
  display: flex;
  align-items: center;
}

.page-head {
  position: relative;
}

.btn-container {
  position: absolute;
  top: 8px;
  right: 8px;
}

.detail-btn {
  background: #c7e9f600;
  padding: 2.4px 5px;
  color: #49d8ec;
  font-size: 12px;
  border-radius: 6.4px;
  border: 1.6px solid #49d8ec;
  box-shadow: 0 0 20px rgba(0, 191, 255, 0.4), inset 0 0 12px rgba(0, 191, 255, 0.5),
    inset 0 0 2px rgba(255, 255, 255, 0.3);
  cursor: pointer;
}

.detail-btn img {
  height: 8px;
  width: 8px;
}
</style>
